import { useCallback, useState } from 'react';
import { type ConfirmStorageKey, persistentStorage } from '../storage';
import { type ConfirmData, useConfirm } from './useConfirm';

export type ConfirmOnceData = {
    name: ConfirmStorageKey;
};

export const useConfirmOnce = ({ name }: ConfirmOnceData & Partial<ConfirmData>) => {
    const [isShowed, setIsShowed] = useState(persistentStorage.getItem(name) === '1');

    const { confirm: confirmModal, renderConfirmModal } = useConfirm();

    const confirm = useCallback(
        async (props: ConfirmData): Promise<boolean> => {
            const confirmed = await confirmModal({ ...props });

            persistentStorage.setItem(name, '1');
            setIsShowed(true);

            return confirmed;
        },
        [name, confirmModal]
    );

    return {
        isShowed,
        renderConfirmModal: isShowed ? () => null : renderConfirmModal,
        confirm: isShowed ? () => Promise.resolve(true) : confirm,
    };
};
